export class ProductForm extends window.BAO.CustomElement() {
  constructor () {
    super()

    this.timeout = null
    this.delay = 4200

    this.formClasses = {
      loading:
        this.form.dataset.loadingClass !== undefined
          ? this.form.dataset.loadingClass
          : 'loading',
      added:
        this.form.dataset.addedClass !== undefined
          ? this.form.dataset.addedClass
          : 'added',
    }
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(this.form, 'submit', (event) => {
      event.preventDefault()

      if (this.classList.contains(this.formClasses.loading)) return

      this.onSubmitHandler()
    })

    this.listeners.add(this.form, 'variant:change', (event) => {
      const variantName = event.detail.data.variant

      this.form.dataset.variantName = variantName

      this.onSubmitHandler()
    })

    if (this.els?.['variant-select']?.exists) {
      this.listeners.add(
        this.els['variant-select'].element,
        'change',
        (event) => {
          this.onVariantSelectChange(event)
        },
      )
    }

    if (this.form.dataset.updateFormStatus === 'true') {
      window.BAO.eventBus.addEventListener(
        window.BAO.EVENTS.PUSH_CART.BEFORE_ADD_FROM_FORM,
        () => {
          this.classList.add(this.formClasses.loading)
          this.ariaBusy = 'true'
          this.classList.remove(this.formClasses.added)
        },
      )

      window.BAO.eventBus.addEventListener(
        window.BAO.EVENTS.PUSH_CART.AFTER_ADD_FROM_FORM,
        () => {
          this.classList.remove(this.formClasses.loading)
          this.ariaBusy = 'false'
          this.classList.add(this.formClasses.added)

          this.timeout = setTimeout(() => {
            this.classList.remove(this.formClasses.added)
            this.resetForm()
          }, this.delay)
        },
      )

      window.BAO.eventBus.addEventListener(window.BAO.EVENTS.CART.ERROR, () => {
        this.classList.remove(this.formClasses.loading)
        this.ariaBusy = 'false'
        this.classList.remove(this.formClasses.added)
      })
    }
  }

  checkValidity () {
    super.checkValidity()

    if (!this.form) {
      this.throwError(`needs to be wrapped around a product's <form> element`)
    }
  }

  resetForm () {
    this.form.reset()
    window.history.replaceState(
      { path: window.location.pathname },
      '',
      window.location.pathname,
    )
  }

  async onSubmitHandler () {
    await this.addToCart()
  }

  async addToCart () {
    return window.BAO.Cart.addItemFromForm(this.form)
  }

  onVariantSelectChange (event) {
    const selectedOption = event.target.selectedOptions[0]
    const variantId = selectedOption.value
    const variantAvailable = selectedOption.dataset.available === 'true'

    this.els.submit.element.dataset.variantId = variantId
    this.els.submit.element.dataset.variantAvailable = variantAvailable
    this.els.submit.element.disabled = !variantAvailable
  }

  /**
   * @returns {HTMLFormElement|null}
   */
  get form () {
    return this.querySelector('form')
  }
}

customElements.define('product-form', ProductForm)
